import { render, staticRenderFns } from "./MerchantPortrait.vue?vue&type=template&id=13c96326&scoped=true"
import script from "./MerchantPortrait.vue?vue&type=script&lang=js"
export * from "./MerchantPortrait.vue?vue&type=script&lang=js"
import style0 from "./MerchantPortrait.vue?vue&type=style&index=0&id=13c96326&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c96326",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c96326')) {
      api.createRecord('13c96326', component.options)
    } else {
      api.reload('13c96326', component.options)
    }
    module.hot.accept("./MerchantPortrait.vue?vue&type=template&id=13c96326&scoped=true", function () {
      api.rerender('13c96326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/paycools/Sidebar/MerchantPortrait.vue"
export default component.exports